import React from 'react';
import { CompassIcon } from 'lucide-react';
import { ButtonLink } from '../components/ui/Button';
export function NotFound() {
  return <div className="flex flex-1 flex-col items-center justify-center bg-white px-6 py-24 text-center" data-id="element-494" data-mp="w4jc55wxqock">
      <span className="flex h-14 w-14 items-center justify-center rounded-full bg-ink-100 text-ink-400" data-id="element-495" data-mp="104jqkqk1azjm">
        <CompassIcon className="h-6 w-6" data-id="element-496" data-mp="152uygvqrqzz7" />
      </span>
      <h1 className="mt-5 text-[19px] font-bold text-ink-900" data-id="element-497" data-mp="1a4u123eopsv3">Page not found</h1>
      <p className="mt-1 max-w-sm text-[13px] text-ink-500" data-id="element-498" data-mp="1f2lux2yw3p1x">
        The page you&apos;re looking for doesn&apos;t exist or may have moved.
      </p>
      <ButtonLink to="/overview" className="mt-6" data-id="element-499" data-mp="1junezb2auk2i">
        Back to Overview
      </ButtonLink>
    </div>;
}